export enum ECommonCounters {
	PWA_INSTALL_CLICK = 89902429,
	PWA_INSTALLED = 89902430,
	PWA_PANEL_CLOSED = 89903955,
}
